import 'babel-polyfill';
import 'regenerator-runtime/runtime';
import 'dom4';
import '@webcomponents/custom-elements';
import 'intersection-observer';
import 'url-polyfill';
import 'whatwg-fetch';
import './events';
import picturefill from 'picturefill';

picturefill();